var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "vessel" } },
    [
      _c("leftcolumn", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: this.$route.name != "officialOpen",
            expression: "this.$route.name != 'officialOpen'",
          },
        ],
      }),
      _c("rightcolumn", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: this.$route.name != "officialOpen",
            expression: "this.$route.name != 'officialOpen'",
          },
        ],
      }),
      _c(
        "transition",
        { attrs: { name: "slide-right", mode: "out-in" } },
        [_c("router-view")],
        1
      ),
      _c("loading", { attrs: { show: _vm.official_loading } }),
      _c("messagebox", { attrs: { messageData: _vm.messageData } }),
      _vm.logpopShow ? _c("Logpop") : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }